<template>
    <div>
        <v-tabs
            show-arrows
            grow
            class="elevation-2 folyamatsav"
            v-if="!hidden"
        >
            <v-tabs-slider
                v-if="true"
                :color="color"/>
            <div v-if="!hidden">
                <v-tab v-for="(page, index) in pages"
                       :to="getPage(page)"
                       :key="pages.indexOf(page)"
                       @click="setPage(pages.indexOf(page))"
                       :disabled="!available(index)"
                >
                    {{ page.title }}
                </v-tab>
            </div>
        </v-tabs>
        <v-layout row>
            <v-flex md12 xs12 mt-2>
                <router-view></router-view>

                <div v-if="!hidden">
                    <v-layout justify-center style="margin-bottom: 20px;">
                        <v-btn
                            key="back"
                            @click="back()"
                            :color="color"
                            v-if="isNotFirst && navigation.backVisible"
                            large
                            text
                            class="button"
                        >
                            {{ navigation.backLabel }}
                        </v-btn>
                        <v-btn
                            key="save"
                            @click="save()"
                            :color="color"
                            v-if="isNotLast && navigation.saveVisible"
                            large
                            class="button"
                        >
                            {{ navigation.saveLabel }}
                        </v-btn>
                        <v-btn
                            key="next"
                            @click="next()"
                            :color="color"
                            v-if="isNotLast && navigation.nextVisible"
                            large
                            class="button"
                        >
                            {{ navigation.nextLabel }}
                        </v-btn>
                    </v-layout>
                </div>
                <v-spacer></v-spacer>

            </v-flex>
            <!--<v-flex md3 hidden-sm-only hidden-xs-only mt-2>
                <slot></slot>
            </v-flex> -->
        </v-layout>
        <v-tabs
            show-arrows
            grow
            class="elevation-2 folyamatsav"
            v-if="!hidden"
        >
            <v-tabs-slider
                style="margin-top:15px;"
                v-if="true"
                :color="color"/>
            <div v-if="!hidden">
                <v-tab
                    v-for="(page, index) in pages"
                    :to="getPage(page)"
                    :key="pages.indexOf(page)"
                    @click="setPage(pages.indexOf(page))"
                    :disabled="!available(index)"
                >
                    {{ page.title }}
                </v-tab>
            </div>
        </v-tabs>

    </div>
</template>
<script>

import { COLOR_TYPE } from '../../modules/AppTheme';
import EventBus from '../../modules/EventBus';
import navigation from '../../modules/navigation';

export default {

    data() {
        return {
            navigation,
        };
    },

    beforeCreate() {
        EventBus.$on('hide-back', () => {
            this.navigation.backVisible = false;
        });

        EventBus.$on('hide-save', () => {
            this.navigation.saveVisible = false;
        });

        EventBus.$on('hide-next', () => {
            this.navigation.nextVisible = false;
        });

        EventBus.$on('show-back', () => {
            this.navigation.backVisible = true;
        });

        EventBus.$on('show-save', () => {
            this.navigation.saveVisible = true;
        });

        EventBus.$on('show-next', () => {
            this.navigation.nextVisible = true;
        });

        EventBus.$on('set-next-button-label', (label) => {
            this.navigation.nextLabel = label;
        });

        EventBus.$on('disable-tabs', () => {
            this.navigation.tabsDisabled = true;
        });
    },
    methods: {
        getPage(page) {
            if (this.$store.getters.tid != null) {
                return { path: `${page.route}/${this.$store.getters.id}/${this.$store.getters.tid}` };
            }
            return { path: page.route };
        },
        available(index) {
            return this.$store.getters.getAvailablePages[index] && !this.navigation.tabsDisabled;
        },
        setPage(index) {
            if (this.available(index)) {
                this.$store.commit('setCurrentPage', index);
            }
        },
        back() {
            this.$manager.back();
        },
        save() {
            this.$manager.save();
        },
        next() {
            this.$manager.next();
        },
    },
    computed: {
        currentPage() {
            return this.$store.getters.currentPage;
        },
        isNotLast() {
            return this.$store.getters.currentPage !== this.$store.getters.getAvailablePages.length - 1;
        },
        isNotFirst() {
            return this.$store.getters.currentPage !== 0;
        },
        getStyle() {
            return `color: ${this.$theme.getColor(COLOR_TYPE.PRIMARY)};`;
        },
    },
    props: {
        pages: {
            type: Array,
            required: true,
        },
        hidden: {
            type: Boolean,
            required: false,
            default: false,
        },
        color: {
            type: String,
            default: 'primary',
        },
    },
};
</script>
<style>
.v-tab {
    color: rgba(0,0,0,.64) !important;
}
.v-tab--disabled {
    opacity: 0.2 !important;
}
.v-tabs__div:has(.v-tabs__item--active) {
    color: #eaeaff !important;
}
</style>
